import { render, staticRenderFns } from "./region.vue?vue&type=template&id=5d6243ea&scoped=true&"
import script from "./region.vue?vue&type=script&lang=js&"
export * from "./region.vue?vue&type=script&lang=js&"
import style0 from "./region.vue?vue&type=style&index=0&id=5d6243ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6243ea",
  null
  
)

export default component.exports